import { SparklesIcon } from 'lucide-react';

import { useAssistantChatOptional } from '@/components/assistant/assistant-chat-context';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from '@/components/ui/tooltip';
import { usePluginStatus } from '@/hooks/use-plugin-status';
import { useEntityFeatures } from '@/hooks/use-entity-features';
import { featureAvailable, navigationFeatureState } from '@/features/tenancy/feature-ui';

/**
 * Header control that opens the AI helper drawer. Mirrors /assistant plugin
 * gating: hidden while checking status; disabled with an explanation when AI
 * is not ready.
 */
export function AssistantLauncher() {
  const { plugins } = usePluginStatus();
  const assistant = useAssistantChatOptional();
  const featureQuery = useEntityFeatures();
  const aiReady = plugins?.ai.status === 'ready';

  if (!aiReady || !featureAvailable(navigationFeatureState(featureQuery), 'ai_tools')) return null;

  // Provider should always wrap the signed-in shell; soft-fail covers HMR races.
  if (!assistant) {
    return (
      <Button
        variant="ghost"
        size="icon"
        disabled
        aria-label="AI assistant loading"
        className="text-muted-foreground"
      >
        <SparklesIcon className="size-5" aria-hidden />
      </Button>
    );
  }

  const { openDrawer, drawerOpen } = assistant;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          onClick={openDrawer}
          aria-label="Open AI booking assistant"
          aria-expanded={drawerOpen}
          aria-haspopup="dialog"
          className="relative"
        >
          <SparklesIcon className="size-5" aria-hidden />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom">AI booking helper</TooltipContent>
    </Tooltip>
  );
}
